import styled from 'styled-components';

import {BannerType, BannerTypes} from 'shared/components/MessageBanner/Themes';
import CloseIcon from 'shared/Icons/components/CloseIcon';
import {Spacing} from 'styles/Base';

const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  height: 24px;
  width: 24px;
  margin-left: ${Spacing.ONE};
`;

interface Props {
  onDismiss(): void;
  type: BannerType;
  'data-testid'?: string;
  dismissAriaLabel?: string;
}

const DismissButton = ({'data-testid': dataTestId, onDismiss, type, dismissAriaLabel}: Props) => {
  const handleClick = () => onDismiss();
  return (
    <Button onClick={handleClick} aria-label={dismissAriaLabel ? dismissAriaLabel : undefined} data-testid={dataTestId}>
      <CloseIcon color={BannerTypes[type].styles.text} />
    </Button>
  );
};

export default DismissButton;
